function menuToggle() {
 let header = document.querySelector('.header');
 if (header) {
  let headerContent = header.querySelector('.header-menu');
  let headerButton = header.querySelector('.menu-toggle');
  let subMenuButton = header.querySelectorAll('.arrow');
  let subMenItem = header.querySelectorAll('.sub-menu LI a');

  headerButton.addEventListener('click', function (e) {
   e.preventDefault();
   headerContent.classList.toggle('is-active');
   headerButton.classList.toggle('is-active');
   document.body.classList.toggle('no-scroll')
  })

  for (let i = 0; i < subMenuButton.length; i++) {
   subMenuButton[i].addEventListener('click', (e) => {
    e.preventDefault();
    subMenuButton[i].parentElement.parentElement.classList.toggle('active')
   })
  }

  for (let d = 0; d < subMenItem.length; d++) {
   subMenItem[d].addEventListener('click', () => {
    headerContent.classList.remove('is-active');
    headerButton.classList.remove('is-active');
    document.body.classList.remove('no-scroll')
   })
  }
 }
}
menuToggle()